import * as API from '../data/inspection_api';
import {GET_LIST, getList,CLEAR_DATA as LIST_CLEAR_DATA} from './listing_action';
import {INSPECTION_API_URL} from "../constants/api_routes";
import {signOutAction} from "./auth_actions";
export const UPDATE_INSPECTION_STATUS = 'update_inspection_status';
export const ASSIGN_JOB_TO_USER = 'assign_job_to_user';
export const INSPECTION_LIST_BY_DATE = 'get_inspection_list_by_date';
export const CREATE_INSPECTION = "create_new_inspection";
export const ADD_ADDITIONAL_NOTES = "update_additional_notes";
export const REPORT_MAP_DATA = "map_data_to_report";
export const SET_INSPECTION_ID = "set_inspection_id";
export const CLEAR_DATA = "reset_inspection_data";
export const RESET_CURRENT_INSPECTION_DETAIL = "reset_current_inspection_detail";
export const SELECTED_INSPECTION_DETAIL = "get_selected_inspection_details";


export function changeStatus(URL, formData,startDate,endDate) {
    return async (dispatch) => {
        const response = await API.changeInspectionStatus(URL, formData);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else{
            dispatch({type: UPDATE_INSPECTION_STATUS, payload: response});
            if(!startDate || !endDate){
                dispatch(getList(URL));
            }
            else {
                dispatch(getInspectionsByDate(URL,startDate,endDate));
            }
        }
    };
}

export function turnDownJob(URL, formData,startDate,endDate) {
    return async (dispatch) => {
        const response = await API.turnDownJob(URL, formData);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else{
            if(!startDate || !endDate){
                dispatch(getList(URL));
            }
            else {
                dispatch(getInspectionsByDate(URL,startDate,endDate));
            }
        }
    };
}

export function assignJob(URL, formData,successCallBack) {
    return async (dispatch) => {
        const response = await API.assignJobToUser(URL, formData);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            successCallBack(response);
            dispatch({type: ASSIGN_JOB_TO_USER, payload: response});
            dispatch(getList(URL));
        }
    };
}

export function getInspectionsByDate(URL, startDate, endDate) {
    return async (dispatch) => {
        dispatch({type:CLEAR_DATA});
        const response = await API.getInspectionByDate(URL, startDate, endDate);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            dispatch({type: INSPECTION_LIST_BY_DATE, payload: response});
        }
    };
}
export function getInspectionsByAddress(URL,address) {
    return async (dispatch) => {
        dispatch({type:CLEAR_DATA});
        const response = await API.getInspectionByAddress(URL,address);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            dispatch({type: INSPECTION_LIST_BY_DATE, payload: response});
        }
    };
}

export function getInspectionsByFilter(URL, inspectionIds) {
    return async (dispatch) => {
        dispatch({type:LIST_CLEAR_DATA});
        const response = await API.getInspectionsByParams(URL,inspectionIds);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            dispatch({type: GET_LIST, payload: response,source: URL});
        }
    };
}

export function createNewInspection( formData,onComplete) {
    return async (dispatch) => {
        const response = await API.createInspection(INSPECTION_API_URL, formData);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            onComplete(response['inspection_id']);
            dispatch({type: CREATE_INSPECTION, payload: response});
        }
    };
}

export function updateInspectionWithAdditionalNotes(URL, formData,additionalDetailsAddedCallBack) {
    return async (dispatch) => {
        const response = await API.updateInspectionWithAdditionalDetails(URL, formData);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            additionalDetailsAddedCallBack(response);
            dispatch({type: ADD_ADDITIONAL_NOTES, payload: response});
        }
    }

}
export function prepareDataForReport(inspectionDataForReport) {
    return async (dispatch) => {
        dispatch({type: REPORT_MAP_DATA, payload: inspectionDataForReport});
    }
}

export function setNewInspectionIdCreated(inspectionId) {
    return async (dispatch) => {
        dispatch({type: SET_INSPECTION_ID,inspectionId:inspectionId});
    }
}

export function deleteInspectionAttachment(attachmentId) {
    return async (dispatch) => {
        await API.removeInspectionAttachment(INSPECTION_API_URL,attachmentId);
    }
}

export function getInspectionDetailById(inspectionId){
    return async (dispatch) => {
        dispatch({type:RESET_CURRENT_INSPECTION_DETAIL});
        const response = await API.getInspectionByInspectionId(inspectionId);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        if(response.success){
            dispatch({type:SELECTED_INSPECTION_DETAIL,payload:response.inspection})
        }
        else {
            dispatch({type:SELECTED_INSPECTION_DETAIL,payload:[]})
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/inspection_action.js